import React from 'react';
import { Link } from 'react-router-dom';
import TopAppBar from '../components/TopAppBar';
import BottomNavBar from '../components/BottomNavBar';

const cards = [
  {
    to: '/admin/users',
    icon: 'group',
    title: 'Users',
    description: 'Manage user accounts and roles.',
  },
  {
    to: '/admin/contractors',
    icon: 'engineering',
    title: 'Contractors',
    description: 'Review, verify, and feature contractor profiles.',
  },
  {
    to: '/admin/categories',
    icon: 'category',
    title: 'Categories',
    description: 'View seeded service categories.',
  },
  {
    to: '/admin/moderators',
    icon: 'shield_person',
    title: 'Moderators',
    description: 'Assign moderator access to admin users.',
  },
  {
    to: '/admin/jobs',
    icon: 'work',
    title: 'Job Review Queue',
    description: 'Review and approve jobs before they go live.',
  },
  {
    to: '/admin/direct-jobs',
    icon: 'forward_to_inbox',
    title: 'Direct Job Review Queue',
    description: 'Review contractor-initiated jobs and quotes before they reach the client.',
  },
];

const AdminDashboardPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-surface-container-lowest font-sans antialiased">
      <TopAppBar />
      <main className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-on-surface mb-8">Admin</h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.map(card => (
            <Link
              key={card.to}
              to={card.to}
              className="bg-surface rounded-2xl shadow-sm border border-outline-variant p-6 flex flex-col gap-3 hover:shadow-md hover:border-primary/30 transition-all group"
            >
              <span className="material-symbols-outlined text-primary text-4xl group-hover:scale-110 transition-transform">
                {card.icon}
              </span>
              <h2 className="text-xl font-semibold text-on-surface">{card.title}</h2>
              <p className="text-on-surface-variant text-sm">{card.description}</p>
            </Link>
          ))}
        </div>
      </main>
      <BottomNavBar />
    </div>
  );
};

export default AdminDashboardPage;
